<mat-expansion-panel 
  hideToggle 
  (opened)="readNotification(notification.id)"
  [ngClass]="{'no_read': !isRead}"
  [ngStyle]="{'border-right': notification.priority ? '0.4rem solid ' + notification.priority.attribute : '0.4rem solid green'}">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="placeholder">
        <mat-icon> {{ notification.type ? notification.type.attribute : '' }}</mat-icon>
      </div>
      <div class="container-title">
        <span class="truncate">{{ notification.title }}</span>
        <span class="truncate subtitle" *ngIf="notification.name">{{ notification.name }}</span>
      </div>
    </mat-panel-title>
    <mat-panel-description>
      <mat-icon
      [matTooltip]="notification.user_id ? 'Notifica personale' : 'Notifica di gruppo'"
      matTooltipPosition="right">
      {{ notification.user_id ? 'person' : 'groups' }}
      </mat-icon>
      <div>
        {{ notification.start_date | date: 'dd/MM/yyyy' }}
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <a class='link' *ngIf="notification.type?.value === 'link'" (click)="download(notification)">Scarica il file</a>
  <p *ngIf="notification.type?.value !== 'link'" [outerHTML]="notification.content"></p>
  </mat-expansion-panel>
